import React from 'react';
import { useTranslation } from 'react-i18next';

const Visualizer = () => {
  const { t } = useTranslation();

  const floorOptions = [
    { name: t('visualizer.options.floors.whiteOak4'), primary: true },
    { name: t('visualizer.options.floors.redOakClassic') },
    { name: t('visualizer.options.floors.whiteOakNordic') },
    { name: t('visualizer.options.floors.whiteOakAmber') },
    { name: t('visualizer.options.floors.whiteOakNatural') },
    { name: t('visualizer.options.floors.redOakProvincial') },
    { name: t('visualizer.options.floors.whiteOakEbony') },
    { name: t('visualizer.options.floors.whiteOakGray') }
  ];

  return (
    <section id="visualizer" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-wood-dark mb-4">
            {t('visualizer.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('visualizer.subtitle')}
          </p>
        </div>

        <div className="bg-gray-50 rounded-xl p-8 shadow-lg">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Upload Area */}
            <div className="bg-white rounded-lg p-8 border-2 border-dashed border-gray-300 text-center">
              <div className="mb-6">
                <svg className="w-16 h-16 mx-auto text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                {t('visualizer.upload.title')}
              </h3>
              <p className="text-gray-600 mb-4">
                {t('visualizer.upload.description')}
              </p>
              <button className="bg-gray-300 text-gray-500 font-semibold py-3 px-6 rounded-lg cursor-not-allowed opacity-50">
                {t('visualizer.upload.button')}
              </button>
            </div>

            {/* Floor Options Preview */}
            <div>
              <h3 className="text-2xl font-semibold text-wood-dark mb-4">
                {t('visualizer.options.title')}
              </h3>
              <div className="space-y-3">
                {floorOptions.map((option, index) => (
                  <div
                    key={index}
                    className={`p-4 rounded-lg border-2 ${
                      option.primary
                        ? 'border-wood-brown bg-wood-light/10'
                        : 'border-gray-200 bg-white'
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <span className={`font-medium ${option.primary ? 'text-wood-dark' : 'text-gray-700'}`}>
                        {option.name}
                      </span>
                      {option.primary && (
                        <span className="bg-wood-brown text-white text-xs px-2 py-1 rounded">
                          {t('visualizer.options.mostPopular')}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Feature Description */}
          <div className="mt-12 bg-blue-50 rounded-lg p-6">
            <h4 className="text-lg font-semibold text-blue-900 mb-2">
              {t('visualizer.feature.title')}
            </h4>
            <p className="text-blue-800">
              {t('visualizer.feature.description')}
            </p>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-12 text-center">
          <p className="text-lg text-gray-600 mb-4">
            {t('visualizer.cta.text')}
          </p>
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-wood-brown hover:bg-wood-dark text-white font-bold py-3 px-8 rounded-lg transition duration-300 transform hover:scale-105"
          >
            {t('visualizer.cta.button')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Visualizer; 